var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 transition"},[_c('GenericReport',{attrs:{"title":"Relatório de Processos","route":_vm.route,"topFilters":_vm.topFilters,"sideFilters":_vm.sideFilters,"tipoRelatorio":"relatorioProcessos","fields":_vm.fields}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }